import {
  BRAND_LOCKUP_COMPACT_PATH,
  BRAND_LOCKUP_PATH,
  BRAND_NAME,
  buildPublicAssetPath,
} from '../../lib/brand';
import { cn } from '../../lib/utils';

interface BrandMarkProps {
  className?: string;
  logoClassName?: string;
}

const brandLockupSrc = buildPublicAssetPath(BRAND_LOCKUP_PATH);
const brandLockupCompactSrc = buildPublicAssetPath(BRAND_LOCKUP_COMPACT_PATH);

export function BrandMark({ className, logoClassName }: BrandMarkProps) {
  return (
    <div className={cn('inline-flex shrink-0 items-center', className)}>
      <picture>
        <source media="(max-width: 640px)" srcSet={brandLockupCompactSrc} />
        <img
          src={brandLockupSrc}
          alt={BRAND_NAME}
          width={150}
          height={150}
          decoding="async"
          className={cn('h-14 w-auto object-contain sm:h-16', logoClassName)}
        />
      </picture>
    </div>
  );
}
